import themes from '../assets/themes/theme-default'
import * as actions from './actions'

const INITIAL_THEME = themes[0]

export const INITIAL_STATE = {
  campaign: null,
  theme: INITIAL_THEME,
  tradeInContext: {
    loading: false
  }
}

export default function configurationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.SET_CONFIGURATION: {
      return action.configuration
    }
    case actions.RESET_CONFIGURATION: {
      return INITIAL_STATE
    }
    case actions.RESET_TRADE_IN_CONTEXT: {
      return {
        ...state,
        tradeInContext: null
      }
    }

    default:
      return state
  }
}
